import React from "react";
import { cn } from "@/lib/utils";

type TimelineLegendShapeProps = {
  shape: "circle" | "diamond";
  fillClass: string;
  ringClass?: string;
  /** Legend samples use size-3 circles; toolbar indicator uses size-2.5 */
  size?: "sm" | "md";
  className?: string;
};

const TimelineLegendShape: React.FC<TimelineLegendShapeProps> = ({
  shape,
  fillClass,
  ringClass,
  size = "md",
  className,
}) => {
  const sizeClass = size === "sm" ? "size-2.5" : "size-3";

  if (shape === "diamond") {
    return (
      <span
        className={cn(
          "inline-block shrink-0 rotate-45",
          sizeClass,
          fillClass,
          ringClass,
          className
        )}
        aria-hidden
      />
    );
  }

  return (
    <span
      className={cn(
        "inline-block shrink-0 rounded-full",
        sizeClass,
        fillClass,
        ringClass,
        className
      )}
      aria-hidden
    />
  );
};

export default TimelineLegendShape;
